import axios from 'axios'
// @ts-ignore
import { useCookies } from 'vue3-cookies'
import router from '@/router'

// const baseURL = 'http://localhost:8081/api'
const baseURL = import.meta.env.VITE_API_HOST
// const api = axios.create({ baseURL })
const apiAxios = axios.create({ baseURL: '/' })



apiAxios.interceptors.request.use((config) => {
  const token = useCookies().cookies.get('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  // Note: Authentication check moved to router navigation guard
  // to avoid race conditions during app initialization
  return config
})



apiAxios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response.status === 401) {
    useCookies().cookies.remove('token')
    router.push('/auth/login').then()
    return null
  } else {
    return Promise.reject(error)
  }
})
export { apiAxios, baseURL }
